import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent {

}



// WEBPACK FOOTER //
// ./src/app/components/sidebar/sidebar.component.ts